import { getData } from '~/utils/service';
import type { GeographyOption } from './providerServiceListingForm';

// The endpoint matches ZIP prefixes and city prefixes ("Norwalk, OH"); a single character is too
// broad to be useful, so the picker waits for two.
export const MIN_LOCATION_SEARCH_CHARS = 2;

export const searchGeographies = async (query: string): Promise<GeographyOption[]> =>
  getData<GeographyOption[]>('geographySearch', { params: { q: query.trim(), limit: 10 } });
